import { UseClientModelContext } from '@mercadoni/sinister/dist/cjs/client'
import useSearchEventSSR from '@mercadoni/sinister/dist/cjs/monitors/useSearchEventSSR'
import { useHeaderDataContext } from '@mercadoni/sinister/dist/cjs/shared/contexts'

import { useAddressContext } from '@/context/AddressContext'
import { useAuthContext } from '@/context/AuthContext'
import { useOperationalModelContext } from '@/context/OperationalModelContext'
import { useStoreContext } from '@/context/StoreContext'

const useGetSearchEvents = () => {
  const { headerData, version } = useHeaderDataContext()
  const { clientId, currencyCode } = UseClientModelContext()
  const { customer } = useAuthContext()
  const { store } = useStoreContext()
  const { operationalModel } = useOperationalModelContext()
  const { address } = useAddressContext()

  const initialParams = {
    clientId,
    currencyCode,
    customer,
    opsmodel: operationalModel,
    address,
    store,
    headerData,
    version,
    guestId:
      typeof window !== 'undefined'
        ? window?.getCookie?.(window.COOKIE_KEY) || ''
        : '',
  }

  const searchEvents = useSearchEventSSR(initialParams)

  return {
    sendViewSearchResultsEvent: searchEvents.sendViewSearchResultsEvent,
    sendSearchTermEvent: searchEvents.sendSearchTermEvent,
    sendNoSearchResultsEvent: searchEvents.sendNoSearchResultsEvent,
    sendSearchResultsEvent: searchEvents.sendSearchResultsEvent,
  }
}

export default useGetSearchEvents
